module.exports = __webpack_public_path__ + "img/serviceImg3.188ae660.png";